module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-connection-lost"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512.002 512.002"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512.002 512.002",
      "xml:space": "preserve",
      "width": "275",
      "height": "275"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#FFDC64"
    },
    attrs: {
      "d": "M289.605,250.838c-3.024-4.319-7.976-6.895-13.25-6.895l-40.387,0.464l27.79-76.419\n\tc1.565-4.286-0.653-9.024-4.935-10.585c-4.298-1.56-9.024,0.657-10.581,4.94l-27.79,76.415c-1.806,4.956-1.081,10.488,1.944,14.806\n\tc3.024,4.319,7.976,6.895,13.25,6.895l40.387-0.464l-18.675,51.354l-0.148-0.987c-0.669-4.504-4.831-7.621-9.387-6.944\n\tc-4.516,0.673-7.621,4.875-6.952,9.387l5.274,35.258c0.468,3.105,2.653,5.677,5.637,6.641c0.831,0.266,1.685,0.395,2.532,0.395\n\tc2.194,0,4.339-0.875,5.919-2.5l24.847-25.56c3.177-3.274,3.105-8.5-0.161-11.681c-3.2-3.109-8.271-3.065-11.457,0.018\n\tl18.086-49.732C293.355,260.688,292.629,255.156,289.605,250.838z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#00C3FF"
    },
    attrs: {
      "d": "M146.645,231.229H90.839c-4.565,0-8.258-3.698-8.258-8.258s3.694-8.258,8.258-8.258h55.806\n\tc4.347,0,8.605-1.762,11.677-4.839l17.516-17.516c3.226-3.226,8.452-3.226,11.677,0c3.226,3.226,3.226,8.452,0,11.677L170,221.551\n\tC163.855,227.7,155.347,231.229,146.645,231.229z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#E6646E"
    },
    attrs: {
      "d": "M206.452,289.035c-2.113,0-4.226-0.806-5.839-2.419L183.097,269.1\n\tc-3.073-3.077-7.331-4.839-11.677-4.839H82.581c-4.565,0-8.258-3.698-8.258-8.258s3.694-8.258,8.258-8.258h88.839\n\tc8.702,0,17.21,3.528,23.355,9.677l17.516,17.516c3.226,3.226,3.226,8.452,0,11.677\n\tC210.677,288.229,208.565,289.035,206.452,289.035z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#FFDC64"
    },
    attrs: {
      "d": "M173.419,330.325c-2.113,0-4.226-0.806-5.839-2.419l-25.774-25.774\n\tc-3.073-3.077-7.331-4.839-11.677-4.839h-39.29c-4.565,0-8.258-3.698-8.258-8.258s3.694-8.258,8.258-8.258h39.29\n\tc8.702,0,17.21,3.528,23.355,9.677l25.774,25.774c3.226,3.226,3.226,8.452,0,11.677\n\tC177.645,329.519,175.532,330.325,173.419,330.325z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#5D5360"
    },
    attrs: {
      "d": "M121.452,307.971l-11.677-11.677c-3.195-3.197-7.127-5.34-11.403-6.394\n\tc-2.299-0.567-4.129-2.315-5.188-4.433l-8.688-17.375c-1.184-2.368-1.009-5.19,0.46-7.393l12.124-18.187\n\tc1.271-1.907,1.584-4.296,0.847-6.466l-4.198-12.36c-1.08-3.18,0.118-6.684,2.923-8.532c5.931-3.907,15.282-10.086,15.282-10.086\n\tc3.798-2.528,4.823-7.657,2.29-11.452c-2.532-3.802-7.653-4.835-11.452-2.29L84.24,203.681c-2.713,1.809-5.901,2.774-9.163,2.774\n\tH8.258c-4.561,0-8.258,3.697-8.258,8.258v82.581c0,4.561,3.697,8.258,8.258,8.258h84c2.189,0,4.289,0.87,5.837,2.418l11.679,11.679\n\tc1.613,1.613,3.726,2.419,5.839,2.419s4.226-0.806,5.839-2.419C124.677,316.422,124.677,311.196,121.452,307.971z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#4B3F4E"
    },
    attrs: {
      "d": "M0,297.293c0,4.56,3.697,8.258,8.258,8.258h84c2.19,0,4.289,0.869,5.837,2.418l11.679,11.679\n\tc1.613,1.613,3.726,2.419,5.839,2.419s4.226-0.806,5.839-2.419c3.226-3.226,3.226-8.452,0-11.677l-11.677-11.677\n\tc-3.195-3.197-7.127-5.34-11.403-6.394c-2.299-0.567-4.129-2.315-5.188-4.433l-6.474-12.948H0V297.293z"
    }
  }), _vm._v(" "), _c('g', [_c('circle', {
    staticStyle: {
      "fill": "#EBC9A0"
    },
    attrs: {
      "cx": "181.68",
      "cy": "198.191",
      "r": "8.258"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "fill": "#EBC9A0"
    },
    attrs: {
      "cx": "173.42",
      "cy": "322.071",
      "r": "8.258"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "fill": "#EBC9A0"
    },
    attrs: {
      "cx": "206.45",
      "cy": "280.781",
      "r": "8.258"
    }
  })]), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#FFDC64"
    },
    attrs: {
      "d": "M365.355,280.777h55.806c4.565,0,8.258,3.698,8.258,8.258s-3.694,8.258-8.258,8.258h-55.806\n\tc-4.347,0-8.605,1.762-11.677,4.839l-17.516,17.516c-3.226,3.226-8.452,3.226-11.677,0c-3.226-3.226-3.226-8.452,0-11.677\n\tL342,290.454C348.145,284.305,356.653,280.777,365.355,280.777z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#E6646E"
    },
    attrs: {
      "d": "M305.548,222.971c2.113,0,4.226,0.806,5.839,2.419l17.516,17.516\n\tc3.073,3.077,7.331,4.839,11.677,4.839h88.839c4.565,0,8.258,3.698,8.258,8.258s-3.694,8.258-8.258,8.258H340.58\n\tc-8.702,0-17.21-3.528-23.355-9.677l-17.516-17.516c-3.226-3.226-3.226-8.452,0-11.677\n\tC301.323,223.777,303.435,222.971,305.548,222.971z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#00C3FF"
    },
    attrs: {
      "d": "M338.581,181.68c2.113,0,4.226,0.806,5.839,2.419l25.774,25.774\n\tc3.073,3.077,7.331,4.839,11.677,4.839h39.29c4.565,0,8.258,3.698,8.258,8.258s-3.694,8.258-8.258,8.258h-39.29\n\tc-8.702,0-17.21-3.528-23.355-9.677l-25.774-25.774c-3.226-3.226-3.226-8.452,0-11.677\n\tC334.355,182.487,336.468,181.68,338.581,181.68z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#5D5360"
    },
    attrs: {
      "d": "M390.548,204.035l11.677,11.677c3.195,3.197,7.127,5.34,11.403,6.394\n\tc2.299,0.567,4.129,2.315,5.188,4.433l8.688,17.375c1.184,2.369,1.009,5.19-0.46,7.393l-12.124,18.187\n\tc-1.271,1.907-1.584,4.296-0.847,6.466l4.198,12.36c1.08,3.18-0.118,6.684-2.923,8.532c-5.931,3.907-15.282,10.086-15.282,10.086\n\tc-3.798,2.528-4.823,7.657-2.29,11.452c2.532,3.802,7.653,4.835,11.452,2.29l18.532-12.355c2.713-1.809,5.901-2.774,9.163-2.774\n\th66.821c4.561,0,8.258-3.697,8.258-8.258v-82.581c0-4.561-3.697-8.258-8.258-8.258h-84c-2.189,0-4.289-0.87-5.837-2.418\n\tl-11.679-11.679c-1.613-1.613-3.726-2.419-5.839-2.419c-2.113,0-4.226,0.806-5.839,2.419\n\tC387.323,195.583,387.323,200.809,390.548,204.035z"
    }
  }), _vm._v(" "), _c('g', [_c('circle', {
    staticStyle: {
      "fill": "#EBC9A0"
    },
    attrs: {
      "cx": "330.32",
      "cy": "313.811",
      "r": "8.258"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "fill": "#EBC9A0"
    },
    attrs: {
      "cx": "338.58",
      "cy": "189.941",
      "r": "8.258"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "fill": "#EBC9A0"
    },
    attrs: {
      "cx": "305.55",
      "cy": "231.231",
      "r": "8.258"
    }
  })]), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#4B3F4E"
    },
    attrs: {
      "d": "M413.784,272.519c-0.168,1.143-0.094,2.319,0.288,3.442l4.198,12.36\n\tc1.08,3.18-0.119,6.684-2.923,8.532c-5.93,3.907-15.282,10.086-15.282,10.086c-3.798,2.528-4.823,7.657-2.29,11.452\n\tc2.532,3.802,7.653,4.835,11.452,2.29l18.532-12.355c2.714-1.809,5.901-2.774,9.162-2.774h66.822c4.56,0,8.258-3.698,8.258-8.258\n\tV272.52h-98.217V272.519z"
    }
  }), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')]), _vm._v(" "), _c('h6', {
    staticClass: "mb-1"
  }, [_vm._v("Oops!")]), _vm._v(" "), _c('h6', {
    staticClass: "mb-5"
  }, [_vm._v("Connection Lost")]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "proceed-btn"
  }, [_c('button', {
    staticClass: "btn py-md-2 px-md-3",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Retry")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b48ec288","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/connectionLost.vue
// module id = 2839
// module chunks = 0